export const CATEGORIES_MODAL_STATES = {
  newCategory: 'newCategory',
  renameCategory: 'renameCategory',
  deleteCategory: 'deleteCategory',

  newSubCategory: 'newSubCategory',
  renameSubCategory: 'renameSubCategory',
  deleteSubCategory: 'deleteSubCategory',
};
